import React from 'react';

import Card from '../../components/Card';
import Link from '../../components/Link';
import Button, {ButtonSizes} from '../../components/ButtonNew';
import {
  StoryBookIcon,
  AcademicCapIcon,
  ShortRightArrowIcon,
  PathIcon,
} from '../../components/svg';
import {formatLargeNum, clampLines} from '../../util';

export const Placeholder = () => (
  <div className="flex flex-col mb-4 border shadow rounded-lg overflow-hidden animate-pulse">
    <div className="w-full h-36 bg-gray-100" />
    <div className="w-full flex-shrink-0 p-5">
      <div className="h-8 bg-gray-100 rounded w-4/5 mb-2" />
      <div className="h-4 bg-gray-100 rounded w-full mb-2" />
      <div className="h-4 bg-gray-100 rounded w-full mb-4" />
      <div className="h-12 bg-gray-100 rounded w-full" />
    </div>
  </div>
);

const CourseCard = ({
  name,
  description,
  href,
  thumbnail,
  badge,
  numStudents,
  numLessons,
  numCourses,
  isPath,
  onClick,
}) => (
  <Card
    className="relative flex flex-col overflow-hidden cursor-pointer hover:shadow-lg transition duration-50 group"
    onClick={onClick}
    border
  >
    <div className="hidden md:flex flex-col w-full">
      <div className="flex relative -mt-5 -mx-4 sm:-mt-6 sm:-mx-6 mb-5 h-36 justify-center items-center bg-gray-100">
        {thumbnail
          ? (
            <img
              src={`${thumbnail}?w=800&h=800`}
              className="w-full h-full object-cover"
              loading="lazy"
              width="400"
              height="200"
              alt={name}
            />
          ) : <StoryBookIcon className="w-10 h-10 text-gray-400" />}
        <div className="absolute inset-0 w-full h-full bg-gray-200 bg-opacity-10" />
      </div>
      {badge && (
        <div className="absolute top-2 right-2 bg-indigo-200 text-indigo-600 text-xs font-medium rounded-lg px-2 py-1">
          {badge}
        </div>
      )}
    </div>
    <div className="flex flex-col justify-between w-full h-full">
      <div className="flex flex-col items-start">
        {isPath && (
          <div className="mb-1.5 flex items-center bg-gray-800 text-white text-xs font-medium rounded-lg px-2 py-1">
            <PathIcon className="h-4 w-4 mr-1.5" />
            Learning Path
          </div>
        )}
        <Link href={href} onClick={onClick}>
          <h3 className="text-xl font-semibold mb-2">
            {name}
          </h3>
        </Link>
        <div className="mb-2 flex items-center space-x-2 text-sm font-medium text-gray-500">
          {numCourses && (
            <span className="flex items-center">
              <StoryBookIcon className="h-5 mr-1" />
              {`${numCourses} courses`}
            </span>
          )}
          {numLessons && (
            <span className="flex items-center">
              <StoryBookIcon className="h-5 mr-1" />
              {`${numLessons} lessons`}
            </span>
          )}
          {numStudents && (
            <span className="flex items-center">
              <AcademicCapIcon className="h-4 mr-1" />
              {`${formatLargeNum(numStudents, true)} students`}
            </span>
          )}
        </div>
        <p
          className="text-gray-500 mb-3 md:mb-6"
          style={clampLines(2)}
        >
          {description}
        </p>
      </div>
      <Button
        size={ButtonSizes.LARGE}
        className="w-full"
        href={href}
        onClick={onClick}
      >
        Start learning
        <ShortRightArrowIcon stroke="#ffffff" className="w-3 ml-1.5" />
      </Button>
    </div>
  </Card>
);

export default CourseCard;
